<template>
  <section id="home">
    <hero />

    <contents />
  </section>
</template>

<script>
  import Hero from './Hero'
  import Contents from './Contents'

  export default {
    name: 'HomeIndex',

    metaInfo: {
      title: ' Furries of Virginia',
    },

    components: {
      Hero,
      Contents,
    },
      mounted() {

      }
  }
</script>
